import { interviewKitConstants } from "../../_constants";
import axiosInstance from "../../../_helpers/axiosInstance";
import config from "../../../_config/config";
import {
  showSuccessMessage,
  showWarningMessage,
} from "../../../_uiComponents/ShowMessageSnack";

// create interview
export const create_interview_kit_action = (data) => async (dispatch) => {
  dispatch({
    type: interviewKitConstants.CREATE_INTERVIEW_KIT_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(
      config.mentor.createInterviewKit,
      data
    );
    if (response.status) {
      window.location.replace(
        `/create-assessment/${response.data && response.data.data?.id}`
      );
      dispatch({
        type: interviewKitConstants.CREATE_INTERVIEW_KIT_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: interviewKitConstants.CREATE_INTERVIEW_KIT_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);

    return e;
  }
};

//get interview
export const get_all_interview_kit_data_action = () => async (dispatch) => {
  dispatch({
    type: interviewKitConstants.GET_ALL_INTERVIEW_KIT_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(config.mentor.getAllInterviewKit);
    if (response.status) {
      dispatch({
        type: interviewKitConstants.GET_ALL_INTERVIEW_KIT_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: interviewKitConstants.GET_ALL_INTERVIEW_KIT_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);

    return e;
  }
};

//get published interviews
export const get_all_published_interview_kit_data_action =
  () => async (dispatch) => {
    dispatch({
      type: interviewKitConstants.GET_ALL_PUBLISHED_INTERVIEW_KIT_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.mentor.getAllPublishedInterviewKit
      );
      if (response.status) {
        dispatch({
          type: interviewKitConstants.GET_ALL_PUBLISHED_INTERVIEW_KIT_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: interviewKitConstants.GET_ALL_PUBLISHED_INTERVIEW_KIT_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);

      return e;
    }
  };

// update interview
export const update_interview_kit_action = (data, id) => async (dispatch) => {
  dispatch({
    type: interviewKitConstants.UPDATE_INTERVIEW_KIT_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.put(
      config.mentor.updateInterviewKit.replace(":id", id),
      data
    );
    if (response.status) {
      showSuccessMessage("Successfully Updated.");
      dispatch({
        type: interviewKitConstants.UPDATE_INTERVIEW_KIT_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: interviewKitConstants.UPDATE_INTERVIEW_KIT_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);

    return e;
  }
};

//get Interview by id
export const get_interview_kit_by_id_data_action = (id) => async (dispatch) => {
  dispatch({
    type: interviewKitConstants.GET_INTERVIEW_KIT_BY_ID_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.mentor.getInterviewKit.replace(":id", id)
    );
    if (response.status) {
      dispatch({
        type: interviewKitConstants.GET_INTERVIEW_KIT_BY_ID_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: interviewKitConstants.GET_INTERVIEW_KIT_BY_ID_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);

    return e;
  }
};

//delete interview
export const delete_interview_kit_by_id_data_action =
  (id) => async (dispatch) => {
    dispatch({
      type: interviewKitConstants.DELETE_INTERVIEW_KIT_BY_ID_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.delete(
        config.mentor.deleteInterviewKit.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: interviewKitConstants.DELETE_INTERVIEW_KIT_BY_ID_ACTION_SUCCESS,
          payload: response.data,
        });
        showSuccessMessage("Bucket list Deleted Successfully.");
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: interviewKitConstants.DELETE_INTERVIEW_KIT_BY_ID_ACTION_FAILURE,
        payload: e.msg,
      });
      return e;
    }
  };

//assign interview kit
export const assign_interview_kit_job_action =
  (jobId, interviewkitId) => async (dispatch) => {
    dispatch({
      type: interviewKitConstants.ASSIGN_INTERVIEW_KIT_JOB_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        `${config.mentor.assignInterviewkitJob.replace(
          ":id",
          jobId
        )}${interviewkitId}/`
      );

      if (response.status) {
        let data = { data: [] };
        data.data.push(response.data?.data);
        dispatch({
          type: interviewKitConstants.ASSIGN_INTERVIEW_KIT_JOB_ACTION_SUCCESS,
          payload: data,
        });

        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: interviewKitConstants.ASSIGN_INTERVIEW_KIT_JOB_ACTION_FAILURE,
        payload: e.msg,
      });
      return e;
    }
  };

//unassign interview kit
export const unassign_interview_kit_job_action =
  (mappingId) => async (dispatch) => {
    dispatch({
      type: interviewKitConstants.UNASSIGN_INTERVIEW_KIT_JOB_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.delete(
        `${config.mentor.assignInterviewkitJob.replace(":id", mappingId)}`
      );
      if (response.status) {
        dispatch({
          type: interviewKitConstants.UNASSIGN_INTERVIEW_KIT_JOB_ACTION_SUCCESS,
          payload: {},
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: interviewKitConstants.UNASSIGN_INTERVIEW_KIT_JOB_ACTION_FAILURE,
        payload: e.msg,
      });
      return e;
    }
  };

//unassign interview kit
export const get_assigned_interview_kit_job_action =
  (jobId) => async (dispatch) => {
    dispatch({
      type: interviewKitConstants.GET_ASSIGNED_INTERVIEW_KIT_JOB_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.mentor.getAssignedInterviewkitJob.replace(":id", jobId)}`
      );
      if (response.status) {
        dispatch({
          type: interviewKitConstants.GET_ASSIGNED_INTERVIEW_KIT_JOB_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: interviewKitConstants.GET_ASSIGNED_INTERVIEW_KIT_JOB_ACTION_FAILURE,
        payload: e.msg,
      });
      return e;
    }
  };

//get job details
export const set_new_interview_kit_mentor_action = () => async (dispatch) => {
  dispatch({
    type: interviewKitConstants.SET_NEW_INTERVIEW_KIT_MENTOR_ACTION_REQUEST,
  });

  try {
    dispatch({
      type: interviewKitConstants.SET_NEW_INTERVIEW_KIT_MENTOR_ACTION_SUCCESS,
      payload: {},
    });
  } catch (e) {
    dispatch({
      type: interviewKitConstants.SET_NEW_INTERVIEW_KIT_MENTOR_ACTION_FAILURE,
      payload: e.msg,
    });
  }
};

// update interview kit topic
export const update_interview_kit_topic_mentor_action =
  (data, id) => async (dispatch) => {
    dispatch({
      type: interviewKitConstants.UPDATE_INTERVIEW_KIT_TOPIC_MENTOR_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        config.mentor.updateInterviewKitTopic.replace(":id", id),
        data
      );
      if (response.status) {
        dispatch({
          type: interviewKitConstants.UPDATE_INTERVIEW_KIT_TOPIC_MENTOR_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: interviewKitConstants.UPDATE_INTERVIEW_KIT_TOPIC_MENTOR_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);

      return e;
    }
  };

// delete interview kit topic
export const delete_interview_kit_topic_mentor_action =
  (id) => async (dispatch) => {
    dispatch({
      type: interviewKitConstants.DELETE_INTERVIEW_KIT_TOPIC_MENTOR_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.delete(
        config.mentor.updateInterviewKitTopic.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: interviewKitConstants.DELETE_INTERVIEW_KIT_TOPIC_MENTOR_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: interviewKitConstants.DELETE_INTERVIEW_KIT_TOPIC_MENTOR_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);

      return e;
    }
  };

// add interview kit topic question
export const add_interview_kit_topic_question_mentor_action =
  (data) => async (dispatch) => {
    dispatch({
      type: interviewKitConstants.ADD_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.mentor.updateInterviewKitTopicQuestion,
        data
      );
      if (response.status) {
        dispatch({
          type: interviewKitConstants.ADD_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: interviewKitConstants.ADD_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);

      return e;
    }
  };

// add interview kit topic question
export const update_interview_kit_topic_question_mentor_action =
  (data, id) => async (dispatch) => {
    dispatch({
      type: interviewKitConstants.UPDATE_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        `${config.mentor.updateInterviewKitTopicQuestion}${id}/`,
        data
      );
      if (response.status) {
        dispatch({
          type: interviewKitConstants.UPDATE_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: interviewKitConstants.UPDATE_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);

      return e;
    }
  };

// add interview kit topic question
export const delete_interview_kit_topic_question_mentor_action =
  (id) => async (dispatch) => {
    dispatch({
      type: interviewKitConstants.DELETE_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.delete(
        `${config.mentor.updateInterviewKitTopicQuestion}${id}/`
      );
      if (response.status) {
        dispatch({
          type: interviewKitConstants.DELETE_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: interviewKitConstants.DELETE_INTERVIEW_KIT_TOPIC_QUESTION_MENTOR_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);

      return e;
    }
  };

//// add interview kit topic question
export const get_submitted_candidates_list_interview_kit_mentor_action =
  (id, page) => async (dispatch) => {
    dispatch({
      type: interviewKitConstants.GET_SUBMITTED_CANDIDATES_LIST_INTERVIEW_KIT_MENTOR_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        `${config.mentor.getSubmittedCandidatesInterview.replace(
          ":id",
          id
        )}?page=${page}`
      );
      if (response.status) {
        dispatch({
          type: interviewKitConstants.GET_SUBMITTED_CANDIDATES_LIST_INTERVIEW_KIT_MENTOR_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: interviewKitConstants.GET_SUBMITTED_CANDIDATES_LIST_INTERVIEW_KIT_MENTOR_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);

      return e;
    }
  };

//// add interview kit topic question
export const assessment_kit_question_skill_rating_mentor_action =
  (data) => async (dispatch) => {
    dispatch({
      type: interviewKitConstants.ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.post(
        config.mentor.assessmentKitQuestionRating,
        data
      );
      if (response.status) {
        dispatch({
          type: interviewKitConstants.ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: interviewKitConstants.ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);

      return e;
    }
  };

//// add interview kit topic question
export const update_assessment_kit_question_skill_rating_mentor_action =
  (id, data) => async (dispatch) => {
    dispatch({
      type: interviewKitConstants.UPDATE_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        config.mentor.assessmentKitQuestionRatingById.replace(":id", id),
        data
      );
      if (response.status) {
        dispatch({
          type: interviewKitConstants.UPDATE_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: interviewKitConstants.UPDATE_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);

      return e;
    }
  };

//// add interview kit topic question
export const get_assessment_kit_question_skill_rating_mentor_action =
  (id) => async (dispatch) => {
    dispatch({
      type: interviewKitConstants.GET_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.get(
        config.mentor.assessmentKitQuestionRatingById.replace(":id", id)
      );
      if (response.status) {
        dispatch({
          type: interviewKitConstants.GET_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_SUCCESS,
          payload: response.data,
        });
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: interviewKitConstants.GET_ASSESSMENT_KIT_QUESTION_SKILL_RATING_MENTOR_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e?.msg);
      return e;
    }
  };


  
//create remark to interview 
export const add_remark_to_interview_kit_data_action =
(data) => async (dispatch) => {
  dispatch({
    type: interviewKitConstants.ADD_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.post(
      config.mentor.addRemarkToKit,
      data
    );
    if (response.status) {
      dispatch({
        type: interviewKitConstants.ADD_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_SUCCESS,
        payload: response.data,
      });
      showSuccessMessage("Remark Added Sucessfully.")
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: interviewKitConstants.ADD_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e.msg);
  }
};

//Interview kit remark list 
export const get_interview_kit_remarklist_data_action = (id) => async (dispatch) => {
  dispatch({
    type: interviewKitConstants.GET_REMARK_LIST_DATA_ACTION_REQUEST,
  });
  try {
    const response = await axiosInstance.get(
      config.mentor.getRemarkOfKit.replace(":id", id)
    );
    if (response.status) {
      dispatch({
        type: interviewKitConstants.GET_REMARK_LIST_DATA_ACTION_SUCCESS,
        payload: response.data,
      });
      return response.data;
    } else {
      return false;
    }
  } catch (e) {
    dispatch({
      type: interviewKitConstants.GET_REMARK_LIST_DATA_ACTION_FAILURE,
      payload: e.msg,
    });
    showWarningMessage(e?.msg);
    return e;
  }
};


//update remark to interview
export const update_remark_to_interview_kit_data_action =
  (data, id) => async (dispatch) => {
    dispatch({
      type: interviewKitConstants.UPDATE_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_REQUEST,
    });
    try {
      const response = await axiosInstance.put(
        `${config.mentor.addRemarkToKit}${id}/`,
        data
      );
      if (response.status) {
        dispatch({
          type: interviewKitConstants.UPDATE_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_SUCCESS,
          payload: response.data,
        });
        showSuccessMessage("Remark Updated Sucessfully.");
        return response.data;
      } else {
        return false;
      }
    } catch (e) {
      dispatch({
        type: interviewKitConstants.UPDATE_REMARK_TO_INTERVIEW_KIT_DATA_ACTION_FAILURE,
        payload: e.msg,
      });
      showWarningMessage(e.msg);
    }
  };